import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

import Select from '../../form/Select'
import Input from '../../form/Input'

class DerivedSlideConfig extends Component {
    onChangeHandler = ({ name, value }) => {
        const { config } = this.props
        const { slide } = config
        slide[name] = value
    }

    render() {
        const { presentationStore, config } = this.props
        const { slide } = config
        const { kpiOptions, derivedOptions } = presentationStore
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
                <div className="question-select-col">
                    <Select
                        label={i18n.t('powerpoint.labels.selectQuestion')}
                        options={derivedOptions}
                        name="pageQuestionId"
                        onBlur={this.onChangeHandler}
                        defaultValue={slide.pageQuestionId}
                    />
                </div>
                <div className="question-select-col">
                    <Select
                        label={i18n.t('powerpoint.labels.kpi')}
                        options={kpiOptions}
                        name="kpiPageQuestionId"
                        onBlur={this.onChangeHandler}
                        defaultValue={slide.kpiPageQuestionId}
                    />
                </div>
                <div className="question-select-col">
                    <Input
                        name="removeBaseLimit"
                        type="number"
                        onBlur={this.onChangeHandler}
                        label={i18n.t('powerpoint.labels.removeBaseLimit')}
                        cssClass="number-input hover-style"
                    />
                </div>
            </div>
        )
    }
}

DerivedSlideConfig.propTypes = {
    config: PropTypes.object.isRequired,
    kpiOptions: PropTypes.array.isRequired,
}

export default DerivedSlideConfig
